import { IoGameController } from 'react-icons/io5';
import { FaBookOpen, FaTags } from 'react-icons/fa';
import conectadosLogo from '../../assets/conectados/logo.png';
import conectadosBackground from '../../assets/conectados/conectados_background.png';
import bibliquienLogo from '../../assets/bibliquien/Titulo.webp';
import bibliquienBackground from '../../assets/bibliquien/bibliquien_background.webp';
import logoYaLogo from '../../assets/logo-ya/logo.svg';
import { colors } from '../styles/theme';

/**
 * Shared Games Catalog Data
 * 
 * Defines all games available on the Fe en Juego platform along with their:
 * - Commercial status ('available', 'preSale', 'comingSoon')
 * - Visibility & featuring flags for catalog control
 * - Independent actions with individual enabled/disabled states
 * - Definitive application routes
 */
export const gamesCatalog = [
  {
    id: 'conecta2',
    nameKey: 'games.conecta2.name',
    subtitleKey: 'games.conecta2.subtitle',
    descriptionKey: 'games.conecta2.description',
    logo: conectadosLogo,
    bgImage: conectadosBackground,
    status: 'available',
    visible: true,
    featured: true,
    order: 1,
    badgeIcon: IoGameController,
    routes: {
      play: '/conectados',
      product: '/conectados/producto',
    },
    actions: [
      {
        id: 'buy',
        labelKey: 'games.actions.buy',
        route: '/conectados/producto',
        variant: 'secondary',
        enabled: true,
      },
      {
        id: 'playNow',
        labelKey: 'games.actions.playNow',
        route: '/conectados',
        variant: 'primary',
        enabled: true,
      },
    ],
  },
  {
    id: 'bibliquien',
    nameKey: 'games.bibliquien.name',
    subtitleKey: 'games.bibliquien.subtitle',
    descriptionKey: 'games.bibliquien.description',
    logo: bibliquienLogo,
    bgImage: bibliquienBackground,
    backgroundColor: colors.games.bibliquien,
    status: 'preSale',
    visible: true,
    featured: true,
    order: 2,
    badgeIcon: IoGameController,
    routes: {
      play: '/bibliquien',
      product: '/bibliquien/producto',
    },
    actions: [
      {
        id: 'buy',
        labelKey: 'games.actions.buy',
        route: '/bibliquien/producto',
        variant: 'secondary',
        enabled: true,
      },
      {
        id: 'howToPlay',
        labelKey: 'games.actions.howToPlay',
        route: '/bibliquien',
        variant: 'outline',
        enabled: true,
      },
    ],
  },
  {
    id: 'logo-ya',
    nameKey: 'games.logoYa.name',
    subtitleKey: 'games.logoYa.subtitle',
    descriptionKey: 'games.logoYa.description',
    logo: logoYaLogo,
    status: 'comingSoon',
    visible: false,
    featured: false,
    order: 3,
    badgeIcon: FaTags,
    routes: {
      play: '/logo-ya',
      product: '/logo-ya/producto',
    },
    actions: [
      {
        id: 'buy',
        labelKey: 'games.actions.buy',
        route: '/logo-ya/producto',
        variant: 'secondary',
        enabled: true,
      },
      {
        id: 'howToPlay',
        labelKey: 'games.actions.howToPlay',
        route: '/logo-ya',
        variant: 'outline',
        enabled: true,
      },
    ],
  },
];

/**
 * Returns games filtered by visibility and sorted by order
 */
export const getVisibleGames = () => {
  return gamesCatalog
    .filter((game) => game.visible)
    .sort((a, b) => a.order - b.order);
};

/**
 * Finds a game in the catalog by its ID
 */
export const getGameById = (id) => {
  return gamesCatalog.find((game) => game.id === id);
};

export default gamesCatalog;
